module.exports = __webpack_public_path__ + "static/img/he1.2af6347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he1.png
// module id = bJ4p
// module chunks = 1